<template>
  <div class="link-type">
    <span v-if="value.type==='hyperlink'"><a :href="value.hyperlink" target="_blank">【外部链接】{{value.hyperlink}}</a></span>
    <span v-if="value.type==='product'">【商品详情】{{value.product&&value.product.title}}</span>
    <span v-if="value.type==='products'">【商品列表】{{value.products&&value.products.title}}</span>
    <span v-if="value.type==='article'">【推文】{{value.article&&value.article.title}}</span>
    <span v-if="value.type==='articles'">【推文列表】{{value.articles&&value.articles.title}}</span>
    <span v-if="value.type==='miniapp'">【小程序】{{value.miniapp&&value.miniapp.title}}</span>
    <span v-if="value.type==='video'">【视频】{{value.video_src}}</span>
    <span v-if="value.type==='videoPay'">【付费视频】{{value.videoPay.title}}</span>
    <i class="el-icon-edit" v-if="edit" @click="showLayer"></i>
    <el-dialog :append-to-body="true" title="链接到" center :visible.sync="show" width="800px">
      <el-form label-width="100px">
        <el-form-item label="链接类型">
          <el-select v-model="form.type" placeholder="请选择类型" style="width:150px;" @change="initData">
            <el-option
              label="第三方链接"
              value="hyperlink">
            </el-option>
            <el-option
              label="商品详情"
              value="product">
            </el-option>
            <el-option
              label="推文"
              value="article">
            </el-option>
            <el-option
              label="推文列表"
              value="articles">
            </el-option>
            <el-option
              label="商品列表"
              value="products">
            </el-option>
            <el-option
              label="小程序"
              value="miniapp">
            </el-option>
            <el-option
              label="视频"
              value="video">
            </el-option>
            <el-option
              label="付费视频"
              value="videoPay">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="外部url" v-if="form.type==='hyperlink'">
          <el-input v-model="form.hyperlink" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="商品" v-if="form.type==='product'">
          <template v-if="is_init">
            <select-product
              v-model="productList"
              :limit="1">
            </select-product>
          </template>
        </el-form-item>
        <el-form-item label="推文" v-if="form.type==='article'">
          <el-select v-model="form.article.id" placeholder="请选择" style="width:300px;" filterable>
            <el-option
              v-for="(item,index) in article"
              :key="index"
              :label="item.title"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推文分类" v-if="form.type==='articles'">
          <el-cascader
            :options="category"
            v-model="form.articles.category"
            change-on-select
            :props="{value:'id',label:'title',children:'sub_categories'}">
          </el-cascader>
        </el-form-item>
        <el-form-item label="商品列表" v-if="form.type==='products'">
          <el-form class="products-form" label-width="100px" label-position="left">
            <el-form-item label="标题">
              <el-input v-model="form.products.title" placeholder="标题"></el-input>
            </el-form-item>
            <el-form-item label="商品类型" style="margin: 10px 0;">
              <el-radio-group v-model="form.products.productType" @change="productTypeChange">
                <el-radio label="appoint">指定分类</el-radio>
                <el-radio label="custom">自定义商品</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="form.products.productType==='custom'" label="商品" style="margin: 10px 0;">
              <template v-if="is_init">
                <select-product
                  v-model="productList"
                  :limit="100">
                </select-product>
              </template>
            </el-form-item>
            <el-form-item v-if="form.products.productType==='appoint'" label="商品分类">
              <el-cascader
                :options="category"
                v-model="form.products.category"
                change-on-select
                :props="{value:'id',label:'title',children:'sub_categories'}">
              </el-cascader>
            </el-form-item>
            <el-form-item label="仅限团购">
              <el-switch
                v-model="form.products.is_limit_group_buying"
                :active-value="1"
                :inactive-value="0">
              </el-switch>
            </el-form-item>
            <el-form-item label="仅限集赞">
              <el-switch
                v-model="form.products.is_limit_collect_like"
                :active-value="1"
                :inactive-value="0">
              </el-switch>
            </el-form-item>
          </el-form>
        </el-form-item>
        <el-form-item v-if="form.type==='miniapp'" label="小程序">
          <el-select v-model="form.miniapp.appid" placeholder="请选择" style="width:150px;" @change="miniapp">
            <el-option
              label="两眼抹黑"
              value="wx16d72a642d425362">
            </el-option>
            <el-option
              label="内耳"
              value="wx0392943b2cd44a31">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.type==='miniapp'" label="路径">
          <el-input v-model="form.miniapp.url" placeholder="小程序路径，默认首页" style="width: 600px"></el-input>
        </el-form-item>
        <el-form-item label="视频资源" v-if="form.type==='video'">
          <el-input v-model="form.video_src" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="付费视频" v-if="form.type==='videoPay'">
          <el-select v-model="form.videoPay.uuid" placeholder="请选择" style="width:300px;" filterable>
            <el-option
              v-for="(item,index) in video"
              :key="index"
              :label="item.title"
              :value="item.uuid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickHandle">确 认</el-button>
          <el-button @click="cancelHandle">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import request from '@/utils/request'
import SelectProduct from '@/components/SelectProduct/SelectProduct'
export default {
  name: 'EditLayer',
  components: {
    SelectProduct
  },
  props: {
    value: {
      type: [Object, Array],
      default: _ => {
        return {}
      }
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      show: false,
      article: [],
      category: [],
      form: {
        miniapp: {
          appid: (this.value.miniapp && this.value.miniapp.appid) || '',
          title: (this.value.miniapp && this.value.miniapp.title) || '',
          url: (this.value.miniapp && this.value.miniapp.url) || ''
        },
        type: this.value.type,
        hyperlink: this.value.hyperlink,
        product: this.value.product,
        products: {
          type: 'products',
          productType: (this.value.products && this.value.products.productType) || 'appoint',
          title: (this.value.products && this.value.products.title) || '',
          ids: (this.value.products && this.value.products.ids) || [],
          category: (this.value.products && this.value.products.category) || [],
          is_limit_group_buying: (this.value.products && this.value.products.is_limit_group_buying) || 0,
          is_limit_collect_like: (this.value.products && this.value.products.is_limit_collect_like) || 0
        },
        article: {
          id: (this.value.article && this.value.article.id) || '',
          uuid: (this.value.article && this.value.article.uuid) || '',
          title: (this.value.article && this.value.article.title) || ''
        },
        articles: {
          category: (this.value.articles && this.value.articles.category) || [],
          title: (this.value.articles && this.value.articles.title) || ''
        },
        video_src: this.value.video_src || '',
        videoPay: {
          title: (this.value.videoPay && this.value.videoPay.title) || '',
          uuid: (this.value.videoPay && this.value.videoPay.uuid) || '',
          id: (this.value.videoPay && this.value.videoPay.id) || ''
        }
      },
      productList: [],
      is_init: false,
      productType: '',
      video: []
    }
  },
  watch: {
    value: {
      handler (value) {
        this.form = {
          miniapp: {
            appid: (value.miniapp && value.miniapp.appid) || '',
            title: (value.miniapp && value.miniapp.title) || '',
            url: (value.miniapp && value.miniapp.url) || ''
          },
          type: value.type,
          hyperlink: value.hyperlink,
          product: value.product,
          products: {
            type: 'products',
            productType: (value.products && value.products.productType) || 'appoint',
            title: (value.products && value.products.title) || '',
            ids: (value.products && value.products.ids) || [],
            category: (value.products && value.products.category) || [],
            is_limit_group_buying: (value.products && value.products.is_limit_group_buying) || 0,
            is_limit_collect_like: (value.products && value.products.is_limit_collect_like) || 0
          },
          article: {
            id: (value.article && value.article.id) || '',
            uuid: (value.article && value.article.uuid) || '',
            title: (value.article && value.article.title) || ''
          },
          articles: {
            category: (value.articles && value.articles.category) || [],
            title: (value.articles && value.articles.title) || ''
          },
          video_src: value.video_src || '',
          videoPay: {
            title: (value.videoPay && value.videoPay.title) || '',
            uuid: (value.videoPay && value.videoPay.uuid) || '',
            id: (value.videoPay && value.videoPay.id) || ''
          }
        }
      },
      deep: true
    }
  },
  created () {
    if (this.value.product) {
      this.productList = [this.value.product]
    }
    this.initData(this.value.type)
  },
  methods: {
    showLayer () {
      this.is_init = true
      this.show = true
    },
    initData (e) {
      this.getArticle(e)
      this.getCategory(e)
      this.getProductList(e)
      this.getVideo(e);
      this.productList = []
    },
    miniapp (e) {
      if (e === 'wx16d72a642d425362') this.form.miniapp.title = '两眼抹黑'
      if (e === 'wx0392943b2cd44a31') this.form.miniapp.title = '内耳'
    },
    getVideo(e) {
      if (e === 'videoPay') {
        let sendData = {
          page: 1,
          per_page: 500
        }
        request({
          url: 'video',
          method: 'get',
          params: sendData
        }).then(res => {
          this.video = res.data.list
        })
      }
    },
    getArticle (e) {
      if (e === 'article') {
        let sendData = {
          page: 1,
          per_page: 500
        }
        request({
          url: 'articles',
          method: 'get',
          params: sendData
        }).then(res => {
          this.article = res.data.list
        })
      }
    },
    getCategory (e) {
      if (e === 'products' || e === 'articles') {
        request({
          url: 'categories?type=global'
        }).then(res => {
          res.data.list.unshift({
            id: '',
            title: '综合',
            sub_categories: []
          })
          this.category = res.data.list
        })
      }
    },
    getProductList (e) {
      let products = this.form.products
      if (e === 'products' && products.ids.length > 0) {
        let sendData = {
          page: 1,
          per_page: 500,
          ids: products.ids,
          category: '',
          is_limit_group_buying: products.is_limit_group_buying,
          is_limit_collect_like: products.is_limit_collect_like,
          sort: 'default'
        }
        request({
          url: 'products',
          method: 'get',
          params: sendData
        }).then(res => {
          this.productList = res.data.list
        })
      }
    },
    productTypeChange (e) {
      this.form.products.category = []
      this.form.products.ids = []
      this.productList = []
    },
    cancelHandle () {
      this.show = false
    },
    clickHandle () {
      let data = {}
      let value = this.form
      data.type = value.type
      if (value.type === 'product') {
        let product = this.productList[0] || {}
        data.product = product
        value.product = product
      }
      if (value.type === 'article') {
        let article = this.article
        for (let i = 0; i < article.length; i++) {
          if (article[i].id === this.form.article.id) {
            data.article = {
              id: article[i].id,
              uuid: article[i].uuid,
              title: article[i].title
            }
            break
          }
        }
      }
      if (value.type === 'articles') {
        let value = this.form.articles.category
        if (value.length) {
          let category = this.category
          for (let i = 0; i < category.length; i++) {
            if (category[i].id === value[0]) {
              this.form.articles.title = category[i].title
              if (value[1]) {
                for (let j = 0; j < category[i].sub_categories.length; j++) {
                  if (category[i].sub_categories[j].id === value[1]) {
                    this.form.articles.title = this.form.articles.title + ' / ' + category[i].sub_categories[j].title
                    break
                  }
                }
              }
              break
            }
          }
          data.articles = {
            category: value,
            title: this.form.articles.title
          }
        }
      }
      if (value.type === 'hyperlink') {
        data.hyperlink = value.hyperlink
      }
      if (value.type === 'products') {
        data.products = value.products
        let ids = []
        this.productList.forEach(item => {
          ids.push(item.id)
        })
        value.products.ids = ids
      }
      if (value.type === 'miniapp') {
        data.miniapp = {
          appid: this.form.miniapp.appid,
          title: this.form.miniapp.title,
          url: this.form.miniapp.url
        }
      }
      if (value.type === 'video') {
        data.video_src = value.video_src
      }
      if (value.type === 'videoPay') {
        data.videoPay =  {
          title: this.getVideoTitle(this.form.videoPay.uuid),
          uuid: this.form.videoPay.uuid,
          id: this.getVideoId(this.form.videoPay.uuid)
        }
      }
      this.$emit('input', data)
      this.show = false
    },
    getVideoTitle(uuid) {
      for (let i = 0; i < this.video.length; i++) {
        if (this.video[i].uuid === uuid) {
          return this.video[i].title
        }
      }
    },
    getVideoId(uuid) {
      for (let i = 0; i < this.video.length; i++) {
        if (this.video[i].uuid === uuid) {
          return this.video[i].id
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.link-type {
  display: flex;
  align-items: center;
  line-height: 1.2em;
  span {
    max-width: 250px;
    word-break: break-word;
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: #409EFF;
    cursor: pointer;
  }
  i {
    color: #F56C6C;
    cursor: pointer;
    margin-left: 5px;
  }
}
.products-form {
  background-color: #f5f5f5;
  padding: 20px 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/link/link.vue